import { getUserTimezone } from './GetUserTimezone'

const getTodayInUserTimezone = (): string => {
  const now = new Date()
  const timezone = getUserTimezone()
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  return formatter.format(now)
}

export default getTodayInUserTimezone
